/**
 * V79: 소수년 → "N년 N개월" 포맷
 *
 * 규칙:
 * - 정수년: "N년"
 * - 연+개월: "N년 N개월"
 * - 1년 미만: "N개월"
 * - 0: "0개월"
 * - 반올림: months = Math.round(decimal × 12)
 * - 반올림 결과 12개월 → 연+1 / 0개월로 승격
 *
 * 예시:
 *  - 12.0  → "12년"
 *  - 12.5  → "12년 6개월"
 *  - 9.4   → "9년 5개월"
 *  - 0.5   → "6개월"
 *  - 1.99  → "2년" (0.99×12=11.88 → round=12 → 2년)
 *  - 0.0   → "0개월"
 */
export function formatYearsMonths(years: number | null | undefined): string {
  if (years == null || isNaN(years)) return '0개월';

  const sign = years < 0 ? '-' : '';
  const abs = Math.abs(years);

  let wholeYears = Math.floor(abs);
  const decimal = abs - wholeYears;
  let months = Math.round(decimal * 12);

  // 반올림 결과 12개월이면 연 +1, 개월 0으로 승격
  if (months === 12) {
    wholeYears += 1;
    months = 0;
  }

  if (wholeYears === 0 && months === 0) return '0개월';
  if (wholeYears > 0 && months > 0) return `${sign}${wholeYears}년 ${months}개월`;
  if (wholeYears > 0) return `${sign}${wholeYears}년`;
  return `${sign}${months}개월`;
}
